/**
 * Debounced header mail-badge refresh.
 * Collapses burst SSE events into one count API call; does not touch Inbox list.
 */
const DEFAULT_DELAY_MS = 1200;

let timer = null;

export const scheduleMailBadgeRefresh = (delayMs = DEFAULT_DELAY_MS) => {
  if (timer) {
    clearTimeout(timer);
  }
  timer = setTimeout(() => {
    timer = null;
    window.dispatchEvent(new CustomEvent('mail-badge-updated'));
  }, delayMs);
};

export const cancelMailBadgeRefresh = () => {
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
};
